import React from "react";
import { InputLabel, Stack } from "@mui/material";
import { StyledBox, StyledTextField, StyledTypography } from "../style.module";
import { Controller, useFormContext } from "react-hook-form";
import { IsLoggedInUserViewer } from "../../../hoc/withAuthRedirect";

const FormTextField = ({ name, elementId, isRequired, inputLabel, subtext, inputType, isDisabled }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const preventNegativeInput = (e) => {
    if (inputType === "number" && (e.key === '-' || e.key === 'e' || e.key === 'E')) {
      e.preventDefault(); // Prevent negative sign or scientific notation
    }
  };

  return (
    <Stack autoComplete="off">
      <InputLabel htmlFor={elementId}>
        <StyledBox>
          {isRequired && (
            <StyledTypography variant="subtitle2" gutterBottom typostyle={{ color: "red" }}>
              *
            </StyledTypography>
          )}
          <StyledTypography variant="subtitle2" gutterBottom typostyle={{ color: "#000000", fontSize: "0.8rem" }}>
            {inputLabel}
          </StyledTypography>
        </StyledBox>
      </InputLabel>
      {subtext && (
        <div
          style={{
            color: "gray",
            display: "block",
            marginTop: "0.1rem",
            fontSize: "0.65rem",
          }}
        >
          {subtext}
        </div>
      )}
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <StyledTextField
            {...field}
            id={elementId}
            variant="outlined"
            placeholder={inputLabel}
            type={inputType}
            error={!!errors[name]}
            helperText={errors[name] ? errors[name].message : ""}
            disabled={IsLoggedInUserViewer() || isDisabled}
            onKeyDown={preventNegativeInput} // Prevent negative input
            onChange={(e) =>
              inputType === "number" ? field.onChange(e.target.valueAsNumber) : field.onChange(e.target.value)
            }
            sx={{
              backgroundColor: isDisabled ? "rgba(0, 0, 0, 0.06)" : "white", // Greyed out background when disabled
            }}
          />
        )}
      />
    </Stack>
  );
};

export default FormTextField;
